import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines } from "./motion";
import { ArchShape } from "./BrandShapes";
import { ease } from "../lib/content";

export const PageHeader = ({ eyebrow, lines, intro, testId, children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 140]);
  return (
    <section ref={ref} data-testid={testId} className="grain relative overflow-hidden bg-teal pb-20 pt-36 text-mist sm:pb-28 sm:pt-44">
      <motion.div style={{ y }} className="pointer-events-none absolute -right-16 bottom-[-30%] w-[22rem] text-sage/15 sm:w-[30rem] lg:right-10">
        <ArchShape strokeWidth={8} />
      </motion.div>
      <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <motion.p className="label-caps !text-sm text-sage sm:!text-base" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, ease, delay: 0.1 }}>
          {eyebrow}
        </motion.p>
        <MaskLines
          as="h1"
          onLoad
          delay={0.2}
          lines={lines}
          className="mt-6 max-w-5xl font-display text-[2.6rem] font-normal leading-[0.98] tracking-[-0.02em] sm:text-6xl lg:text-[5.5rem]"
        />
        {intro && (
          <motion.p
            className="mt-8 max-w-2xl text-base leading-relaxed text-mist/85 sm:text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease, delay: 0.6 }}
          >
            {intro}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
};
